import { ReactNode } from 'react'

type Props = {
    children: ReactNode
    noPadding?: boolean
}

/**
 * Wrapper component to center page content and constrain its maximum width.
 *
 * @param param0 - The children elements to be wrapped.
 * @returns A div element that centers its children and limits their width.
 */
export const PageWrapper = ({ children, noPadding }: Props) => (
    <div className="flex h-full w-full justify-center">
        <div className={`flex w-full max-w-[1600px] flex-col items-start gap-6 ${noPadding ? '' : 'p-4'}`}>{children}</div>
    </div>
)
